export const BREAKPOINT = {
  MOBILE: 767,
  TABLET: 1199,
  DESKTOP: 1199,
};
